import { HTTPClient } from "@/utils/request.api";

export default {
  Cartao: ({ payload }) => HTTPClient.post("PagamentoCartao", payload),
  Boleto: ({ payload }) => HTTPClient.post("PagamentoBoleto", payload),
};
